

import React, { memo, useState, useCallback, useEffect } from 'react';
import Mustache from 'mustache';
import { SplashRenderer } from '../../../SplashRenderer';
import { Icon, ClosablePage } from '../../../../ui-kit';







const PreviewSplashTemplates = (props) => {
  const { getTemplateDetails, getUserDetails, history } = props;

  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState(undefined);
  const [user, setUser] = useState(undefined);
  const [brandingColor, setBrandingColor] = useState('');

  const setPreviewContent = useCallback(async () => {
    setLoading(true);
    const { data, error } = await getTemplateDetails();

    if (error || !data || !data.getTemplateDetails) {
      return void 0;
    }

    const {
      contents: templateContents,
      brandingColor: templateBrandingColor
    } = data.getTemplateDetails;

    setContents(templateContents);
    setBrandingColor(templateBrandingColor);
    setLoading(false);
  }, [getTemplateDetails]);

  const onButtonClick = (buttonProperties) => {
    const { buttonLink } = buttonProperties;

    if (buttonLink) {
      let replacedLink = '';

      try {
        const mustacheTemplate = buttonLink.replace(/\$\{(\w+)\}/g, '{{$1}}');
        replacedLink = Mustache.render(mustacheTemplate, user);
      } catch (e) {
        console.error(e);
        replacedLink = buttonLink;
      }

      window.open(replacedLink);
    }
  };

  const setUserDetails = useCallback(async () => {
    const { data, error } = await getUserDetails();

    if (!error) {
      setUser(data.getUser);
    }
  }, [getUserDetails]);

  useEffect(() => {
    setPreviewContent();
    setUserDetails();
  }, [setPreviewContent, setUserDetails]);

  if (loading || !contents || !user) {
    return (
      <main style={{ justifyContent: 'center' }}>
        <Icon name="shootstagrad" size={40} color="black" spin />
      </main>);

  }

  return (
    <div className="preview-splash-templates page">
      <div className="preview-splash-templates__content page__content">
        <ClosablePage
          history={history}
          pageHeaderClassName="preview-splash-templates__content__header"
          contentClassName="preview-splash-templates__content__content">

          <SplashRenderer
            isPreview
            contents={contents}
            replaceVariables={user}
            onButtonClick={onButtonClick}
            brandingColor={brandingColor} />

        </ClosablePage>
      </div>
    </div>);

};

export default memo(PreviewSplashTemplates);